import { Unit, UnitPrefix, BaseUnits } from "uom";
/** Equivalent to <code>KILO(METER)</code>. */
export var Kilometer = UnitPrefix.Kilo("Kilometer", BaseUnits.Meter);
/** Equivalent to <code>CENTI(METRE)</code>. */
export var CentiMeter = UnitPrefix.Centi("CentiMeter", BaseUnits.Meter);
/** Equivalent to <code>MILLI(METRE)</code>. */
export var Millimeter = UnitPrefix.Milli("Millimeter", BaseUnits.Meter);
// Length
export var Foot = Unit.timesNumber("Foot", 0.3048, BaseUnits.Meter);
export var Yard = Unit.timesNumber("Yard", 3.0, Foot);
export var Inch = Unit.divideNumber("Inch", 12.0, Foot);
export var Mile = Unit.timesNumber("Mile", 5280.0, Foot);
export var Decimeter = UnitPrefix.Deci("Decimeter", BaseUnits.Meter);
//# sourceMappingURL=length.js.map